/**
 * Verificador do aparelho para o login pelo SSO (T-028d; DEC-073): fica só nesta aba (sessionStorage) enquanto a
 * pessoa está no provedor; a API devolve o código de retorno, que só vale junto com ele. O e-mail digitado vai junto
 * (a ativação do 2FA mostra a conta).
 */
const PENDING_KEY = 'fluxus.sso.pending';

export type SsoPending = { verifier: string; email: string };

const base64url = (bytes: Uint8Array) =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

/** Verificador novo (32 bytes aleatórios) e o desafio (SHA-256) enviado no início. */
export async function newSsoVerifier(): Promise<{ verifier: string; challenge: string }> {
  const verifier = base64url(crypto.getRandomValues(new Uint8Array(32)));
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return { verifier, challenge: base64url(new Uint8Array(digest)) };
}

/** Guarda o verificador desta aba. Sem armazenamento disponível, o login pelo SSO não tem como continuar. */
export function saveSsoPending(pending: SsoPending): boolean {
  try {
    const value = JSON.stringify(pending);
    sessionStorage.setItem(PENDING_KEY, value);
    return sessionStorage.getItem(PENDING_KEY) === value;
  } catch {
    return false;
  }
}

/** Lê e apaga o que esta aba guardou no início (uso único). */
export function takeSsoPending(): SsoPending | null {
  try {
    const raw = sessionStorage.getItem(PENDING_KEY);
    sessionStorage.removeItem(PENDING_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<SsoPending>;
    return typeof parsed.verifier === 'string' && typeof parsed.email === 'string'
      ? { verifier: parsed.verifier, email: parsed.email }
      : null;
  } catch {
    return null;
  }
}

/** Saída do app para a página de login do provedor (um objeto, para os testes de tela observarem a ida). */
export const ssoBrowser = {
  open(url: string): void {
    window.location.assign(url);
  },
};
